import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchDividendInfo } from '@apis/dividends';
import type { DividendInfoApiData } from '@app-types/dividendApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * React Query hook for the Dividend info block (GET /api/dividends/dividend-info).
 * Reads ticker/mkt from the router location so URL changes refetch.
 */
export const useDividendInfo = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<DividendInfoApiData>({
    queryKey: ['dividends', 'dividend-info', ticker, mkt],
    queryFn: () => fetchDividendInfo({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};
